import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { filter, map, Observable, take } from 'rxjs';
import { AuthStore } from '../../auth/auth.store';
import { User } from '@supabase/supabase-js';
import { SupabaseAuthService } from '../../supabase/supabase-auth.service';
import { ContestSettingsService } from '../services/contest-settings.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<UrlTree | true> => {
  // console.log('\x1b[35m' + `[authGuard called] url: ${state.url}` + '\x1b[0m');

  const _supabaseAuthService = inject(SupabaseAuthService); // don`t delete, necessary for DI!!!
  const _contestSettingsService = inject(ContestSettingsService); // don`t delete, necessary for DI!!!`
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const goesToAuth: boolean = state.url.startsWith('/auth');
  const goesToLogout = state.url.startsWith('/auth/logout');
  const goesToSignup = state.url.startsWith('/auth/sign-up');
  const passwordReset: boolean = state.url.startsWith('/auth/reset-password');

  return authStore?.user$.pipe(
    filter((user: undefined | User | null): user is User | null => user !== undefined),
    take(1),
    map((user: User | null): true | UrlTree => {
      if (!user && !goesToAuth) {
        return router.createUrlTree(['/auth/login']);
      }
      if (user && goesToAuth && !goesToLogout) {
        if (!passwordReset && !goesToSignup) {
          return router.createUrlTree(['/contestant']);
        } else {
          return true;
        }
      }
      return true;
    })
  );
};
